import React, { useState } from 'react';
import FunctionalityAccessHelper from '../../helpers/functionality_access_helper';
import Actions from '../../actions/actions';
import { useSelector } from 'react-redux';
import PageSpinner from '../shared/page_spinner';
import withDataLoaded from '../with_data_loaded';
import { userLoader } from '../../actions/data_loaders';
import UserList from './user_list_pro';
import CompanyPage from './company_page';
import BranchPage from './branch_page';
import NotificationPage from './notification_page';
import LicensePage from './license_page';
import TabManager from './components/tab_manager';
import { ArrowBack as ArrowBackIcon } from '@mui/icons-material';
import { Link } from '@mui/material';
import PricingGroupPage from './pricing_group_page';
import AuthorizedSignerPage from './authorized_signer_page';
import CompanyDetailsPage from './company_details_page';
import FeaturePermissionsHelper from '../../helpers/feature_permissions_helper';

function AdminPage({ subPage }) {
  const cpfDesiredCompany = useSelector((redux) => redux.company);
  const view = useSelector((redux) => redux.view);
  const currUser = useSelector((redux) => redux.user);

  const [startingTab, setStartingTab] = useState(
    {
      pricingGroupList: 'Product Option Groups',
      users: 'Users',
      companies: 'Companies',
      signers: 'Authorized Signers',
      branches: 'Branches',
      company: 'Company',
      notifications: 'Notifications',
      licenses: 'Licenses',
    }[subPage] || 'Users'
  );

  /* eslint-disable  react-hooks/exhaustive-deps */
  React.useEffect(() => {
    setStartingTab(
      {
        pricingGroupList: 'Product Option Groups',
        users: 'Users',
        companies: 'Companies',
        signers: 'Authorized Signers',
        branches: 'Branches',
        company: 'Company',
        notifications: 'Notifications',
        licenses: 'Licenses',
      }[subPage] || 'Users'
    );
  }, [subPage, cpfDesiredCompany]);
  /* eslint-enable  react-hooks/exhaustive-deps */

  let atype = currUser?.atype || '';

  /* eslint-disable  react-hooks/exhaustive-deps */
  React.useEffect(() => {
    if (!window.__aboutToImpersonate && currUser !== null && !FunctionalityAccessHelper.hasAccessToAdmin(currUser)) {
      Actions.setErrorMessages(['Page not found']);
      Actions.setRoute('/proposal/new');
    }
    if (!FeaturePermissionsHelper.hasModule(currUser, 'admin')) {
      Actions.setErrorMessages(['Page not found']);
      // Actions.setRoute('/proposal/new');
    }
    // if (currUser !== null && view.coid && currUser.atype === 'A' && currUser.company.coid.toString() !== view.coid) {
    //   Actions.setErrorMessages(['Page not found']);
    //   Actions.setRoute('/proposal/new');
    // }
  }, [atype, currUser]);
  /* eslint-enable  react-hooks/exhaustive-deps */

  if (currUser === null) {
    return <PageSpinner />;
  }

  const tabs = [
    {
      label: 'Companies',
      idName: 'qa-admin-tab-companies',
      route: '/account/companies',
      content: <CompanyPage />,
      onClick: () => Actions.clearCompanyList(),
      onMount: () => {
        Actions.clearCompanyList();
        Actions.clearCompany();
      },
    },
    {
      label: 'Company',
      idName: 'qa-admin-tab-company-details',
      route: `/account/companies/${view.coid}/companyInfo`,
      content: <CompanyDetailsPage />,
      onClick: () => Actions.clearCompany(),
      onMount: () => Actions.clearCompany(),
    },
    {
      label: 'Users',
      idName: 'qa-admin-tab-users',
      route: `/account/${view.coid ? `companies/${view.coid}/` : ''}users?type=active`,
      content: <UserList />,
      onClick: () => {
        Actions.clearActiveUserList();
        Actions.clearInactiveUserList();
        Actions.clearPricingGroupList();
        Actions.clearPricingGroup();
        Actions.clearUser();
      },
      onMount: () => {
        Actions.fetchUserList({ isActive: true, coid: view.coid });
        Actions.clearPricingGroup();
        Actions.clearUser();
      },
    },
    {
      label: 'Product Option Groups',
      idName: 'qa-admin-tab-pricing',
      route: `/account/companies/${view.coid}/pricing`,
      content: <PricingGroupPage />,
      onClick: () => Actions.clearPricingGroupList(),
      onMount: () => Actions.clearPricingGroupList(),
    },
    {
      label: 'Branches',
      idName: 'qa-admin-tab-branches',
      route: `/account/companies/${view.coid}/branches`,
      content: <BranchPage />,
      onClick: () => Actions.clearBranchList(),
      onMount: () => Actions.clearBranchList(),
    },
    {
      label: 'Authorized Signers',
      idName: 'qa-admin-tab-authorized-signers',
      route: `/account/companies/${view.coid}/signers`,
      content: <AuthorizedSignerPage />,
      onClick: () => Actions.clearAuthorizedSignerList(),
      onMount: () => Actions.clearAuthorizedSignerList(),
    },
    {
      label: 'Notifications',
      idName: 'qa-admin-tab-notification',
      route: `/account/companies/${view.coid}/notifications`,
      content: <NotificationPage />,
      onClick: () => Actions.clearSubscriptionList(),
      onMount: () => Actions.clearSubscriptionList(),
    },
    {
      label: 'Licenses',
      idName: 'qa-admin-tab-licenses',
      route: `/account/companies/${view.coid}/licenses`,
      content: <LicensePage />,
      onClick: () => Actions.clearLicenseList(),
      onMount: () => Actions.clearLicenseList(),
    },
  ];

  let shownTabs = ['Companies', 'Users'];
  if (view.coid) {
    if (currUser.atype === 'CPF') {
      shownTabs = [
        'Company',
        'Product Option Groups',
        'Branches',
        'Users',
        'Authorized Signers',
        'Notifications',
        'Licenses',
      ];
    } else {
      shownTabs = ['Product Option Groups', 'Branches', 'Users', 'Authorized Signers', 'Notifications', 'Licenses'];
    }
  }

  return (
    <div className="admin-page">
      {currUser.atype === 'CPF' && view.coid !== undefined && (
        <Link
          id={'qa-back-to-company-list'}
          className="user-backlink"
          onClick={() => {
            Actions.clearCompanyList();
            Actions.setRoute('/account/companies');
            setStartingTab('Companies');
          }}
        >
          <ArrowBackIcon /> Go Back to Company List
        </Link>
      )}
      <TabManager tabArray={tabs} shownTabs={shownTabs} startingTab={startingTab} idParam={'qa-admin-tabs'} />
    </div>
  );
}

export default withDataLoaded({
  WithData: AdminPage,
  WithoutData: PageSpinner,
  data: [userLoader],
});
